export const numberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const pad = (number, length) => {
    let len = length - (''+number).length;
    return (len > 0 ? new Array(++len).join('0') : '') + number
};

